/* global require */
'use_strict';

/**
 * Creates a mobile search bar.
 */
export class SearchBar {
    /** 
     * @var NodeList body which the search bar will be fixed to.
     * @var NodeList close_button_mobile element to close the search.
     * @var NodeList search_block_grid element to get the search block.
     * @var NodeList adv_search_block_grid element to get the advance search block.
     * @var HTMLCollection input_search element to get the search input.
     * @var HTMLCollection close_icon element of close icon.
     * @var HTMLCollection search_icon element of search icon.
     * @var HTMLCollection container element that holds the form input for search.
     * @var HTMLElement icon_container parent element to close icon.
     */ 

    body: NodeListOf<HTMLBodyElement>;
    close_button_mobile: NodeListOf<Element>;
    search_block_grid: NodeListOf<Element>;
    adv_search_block_grid: NodeListOf<Element>;
    adv_cart_content_grid: NodeListOf<Element>;
    input_search: HTMLCollectionOf<Element>;
    close_icon: HTMLCollectionOf<Element>;
    search_icon: HTMLCollectionOf<Element>;
    container: HTMLCollectionOf<Element>;
    icon_container: HTMLElement;

    /**
     * @returns {SearchBar} setup and ready.
     */
    constructor() {
        this.body = document.querySelectorAll('body');
        this.close_button_mobile = document.querySelectorAll('.tv-close-button-mobile');
        this.search_block_grid = document.querySelectorAll('.search-block-grid');
        this.adv_search_block_grid = document.querySelectorAll('.adv-search-block-grid');
        this.adv_cart_content_grid = document.querySelectorAll('.adv-cart-content-grid');
        this.input_search = document.getElementsByClassName('ty-search-block__input');
        this.close_icon = document.getElementsByClassName('uni-close');
        this.search_icon = document.getElementsByClassName('ty-icon-search');
        this.container = document.getElementsByClassName('ty-search-block');
        this.icon_container = document.getElementById('tv-icon-container');

        const mobile_search = document.getElementsByClassName('search-button-mobile')[0];
        const close_search = document.getElementsByClassName('tv-close-button-mobile')[0];
        mobile_search.addEventListener('click', this.tv_show_search.bind(this));
        close_search.addEventListener('click', this.tv_close_search.bind(this));
        window.addEventListener('resize', this.tv_search_resize_check.bind(this));
    }

    /**
     * Make search appear in mobile.
     *
     * @returns {void}
     */
    tv_show_search () : void {
        for (const bod of this.body ) {
            bod.classList.add('show');
        }

        for (const sbg of this.search_block_grid) {
            sbg.classList.add('show');
        }

        for (const cbm of this.close_button_mobile) {
            cbm.classList.remove('hidden');
        }

        for (const asbg of this.adv_search_block_grid) {
            asbg.classList.add('show');
        }
        
        const input_search_id = document.getElementById('search_input');
        input_search_id.focus();

        this.icon_container.classList.remove('hidden');
        this.container[0].classList.add('ty-search-block-mobile');        
        this.input_search[0].classList.add('tv-height__39px');
        this.search_icon[1].classList.add('tv-search-icon-mobile');
    }

    /**
     * Close mobile search input. 
     * 
     * @returns {void}
     */
    tv_close_search () : void {
        for (const sbg of this.search_block_grid) {
            sbg.classList.remove('show');
        }

        for (const cbm of this.close_button_mobile) {
            cbm.classList.add('hidden');
        }

        for (const asbg of this.adv_search_block_grid) {
            asbg.classList.remove('show');
        }

        for (const accg of this.adv_cart_content_grid) {
            accg.classList.remove('hidden');
        }

        this.icon_container.classList.add('hidden');
        this.container[0].classList.remove('ty-search-block-mobile');  
        this.input_search[0].classList.remove('tv-height__39px');
        this.search_icon[1].classList.remove('tv-search-icon-mobile');
    }

    /**
     * Check if screen size resized out of mobile to close mobile search.
     * 
     * @returns {void}
     */
    tv_search_resize_check() : void {
        const width = document.documentElement.clientWidth;

        if (width > 768) {
            if (document.getElementsByClassName('fixed-top')) {
                for (const bod of this.body) {
                    bod.classList.remove('fixed-top');
                    bod.classList.remove('show');
                }

                this.tv_close_search();
            }
        }
    }
    
}

/**
 * Initialize a new Search Bar.
 * @return {void}
 */
export function init_search_bar() {
    if (document.getElementsByClassName('search-button-mobile').length > 0) {
        (() => new SearchBar())();
    }
}
